/* eslint-disable new-cap */
import $ from 'jquery';
import { HTTP_STATUS_OK } from '../../../smartpak/httpstatus';
import Question from './question';
import customerProfileAPI from '../api/customerprofile';

function Questions(questions, accountId) {
    this.save = function(question) {
        this.clearOtherAnswers(question);

        var dfd = new $.Deferred(),
            json = [this.updateAnswers(question)];

        customerProfileAPI.saveCustomerProfileInfo(JSON.stringify(json)).done(function(result) {
            if (result.Status === HTTP_STATUS_OK) {
                dfd.resolve(result);
            }
        });

        return dfd.promise();
    };

    this.questions = questions
        .map(
            function(question) {
                return Questions.getQuestion(
                    question,
                    accountId,
                    this.save.bind(this)
                );
            }.bind(this)
        )
        .reduce(function(array, question) {
            var ids = array.map(function(q) {
                return q.QuestionId();
            });

            if (ids.indexOf(question.QuestionId()) === -1) {
                array.push(question);
            }

            return array;
        }, []);

    this.getSelectedAnswerForQuestion = function(question) {
        return !question.isCheckBox
            ? [this.formatAnswer(question, question.selectedAnswerId())]
            : question.selectedAnswerIds().map(
                    function(id) {
                        return this.formatAnswer(question, id);
                    }.bind(this)
                );
    };

    this.formatAnswer = function(question, answerId) {
        return {
            AccountId: question.accountId,
            ProfileResultId: 0,
            ProfileQuestionId: question.questionData.QuestionId,
            ProfileAnswerId: answerId ? +answerId : -1,
            FreeTextAnswer: null,
            WizardId: 0
        };
    };

    this.updateAnswers = function(question) {
        var arr = this.getSelectedAnswerForQuestion(question);

        question.questionData.SelectedAnswers = arr;

        return {
            AccountId: question.accountId,
            CancellationHistoryId: -1,
            Question: question.questionData
        };
    };

    this.clearAnswersForDB = function(answers, ids) {
        answers
            .filter(function(answer) {
                return ids.indexOf(answer.AnswerId) === -1 && answer.NextQuestion;
            })
            .map(function(answer) {
                return answer.NextQuestion;
            })
            .forEach(
                function(question) {
                    question.SelectedAnswers = [];
                    this.clearAnswersForDB(question.Answers, ids);
                }.bind(this)
            );
    };

    this.getQuestionIdsToClear = function(answers, ids, questionId) {
        var arr = [];

        answers
            .filter(function(answer) {
                return ids.indexOf(answer.AnswerId) === -1;
            })
            .forEach(
                function(answer) {
                    var nextQuestion = answer.NextQuestion;

                    if (nextQuestion) {
                        arr.push(nextQuestion.QuestionId);
                        arr = arr.concat(this.getQuestionIdsToClear(nextQuestion.Answers, ids, questionId));
                    }
                }.bind(this)
            );

        return arr;
    };

    this.clearAnswersForUI = function(answers, ids, questionId) {
        var foundIds = this.getQuestionIdsToClear(answers, ids, questionId);

        this.questions
            .filter(function(question) {
                return foundIds.indexOf(question.QuestionId()) > -1;
            })
            .forEach(function(question) {
                question.selectedAnswerId(undefined);
                question.selectedAnswerIds([]);
                question.changeAnswer();
            });
    };

    this.clearOtherAnswers = function(question) {
        this.clearAnswersForUI(question.answerData, question.getAnswerIds(), question.QuestionId());
        this.clearAnswersForDB(question.answerData, question.getAnswerIds());
    };

    this.setQuestionDisplay = function() {
        this.questions.forEach(
            function(question, index) {
                var selectedAnswerIds = this.questions
                        .map(function(q) {
                            return +q.selectedAnswerId();
                        })
                        .filter(function(selectedAnswerId) {
                            return selectedAnswerId > -1;
                        }),
                    found = selectedAnswerIds.filter(function(answerId) {
                        return question.PrerequisiteAnswerIds().indexOf(answerId) > -1;
                    });

                question.shouldDisplay(index === 0 || found.length > 0);
            }.bind(this)
        );
    };

    this.setQuestionDisplay();

    this.questions.forEach(
        function(question) {
            question.selectedAnswerId.subscribe(this.setQuestionDisplay.bind(this));
        }.bind(this)
    );
}

Questions.getQuestion = function(data, accountId, save){
    return new Question(data, accountId, save);
};

export default Questions;